/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input.ng-invalid[_ngcontent-%COMP%]{border:1px solid #ff6000}"];
export { styles as styles };
//# sourceMappingURL=phone-input.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/phone-input/phone-input.component.scss.shim.ngstyle.js
// module id = 1437
// module chunks = 27 28 29